import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { acquireAccessToken } from '../../authentication/authConfig';

const fileDownload = async ({ termsId, termsItemId, revision, documentName }) => {
    const token = await acquireAccessToken();
  
    fetch(`${window.config.baseUri}/terms/${termsId}/${termsItemId}/${revision}/document`, {
      method: 'GET',
      headers: {
        'authorization': `Bearer ${token}`
      },
    })
    .then((response) => response.blob())
    .then((blob) => {
      // Create blob link to download
      const url = window.URL.createObjectURL(
        new Blob([blob]),
      );

      const link = document.createElement('a');
      link.href = url;
      link.setAttribute(
        'download',
        `${documentName}.pdf`,
      );

      document.body.appendChild(link);
      link.click();
      link.parentNode?.removeChild(link);
    });
  };

export const downloadFile = createAsyncThunk(
  'download/file',
  async ({ termsId, termsItemId, revision, documentName }, thunkApi) => {
    try {
      return fileDownload({ termsId, termsItemId, revision, documentName });
    } catch (e) {
      return thunkApi.rejectWithValue("Impossible to download");
    }
  }
);

const initialState = {
};

export const fileslice = createSlice({
  name: "file",
  initialState,
  reducers: {},
});

export default fileslice.reducer;